import { Button } from "@/components/ui/button";
import { Bot, Zap, Brain, Smartphone } from "lucide-react";
import { useState } from 'react';
import { ContactForm } from '@/components/LazyContactForm';
import { useMetaPixel } from '@/hooks/useMetaPixel';

const Solution = () => {
  const [showContactForm, setShowContactForm] = useState(false);
  const { trackEvent } = useMetaPixel();

  const handleDemoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Track demo button click
    trackEvent('InitiateContact', {
      source: 'demo_button',
      content_name: 'Ver Demonstração Completa'
    });
    
    setShowContactForm(true);
  };

  const handleChatClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Track chat button click
    trackEvent('InitiateContact', {
      source: 'chat_button',
      content_name: 'Conversar com IA Agora'
    });
    
    setShowContactForm(true);
  };

  const handleFormClose = () => {
    setShowContactForm(false);
  };
  const features = [
    {
      icon: Zap,
      title: "Resposta Imediata",
      description: "Responde leads em segundos, 24/7, sem depender de horário comercial"
    },
    {
      icon: Brain,
      title: "Qualificação Inteligente",
      description: "IA treinada para identificar e priorizar as melhores oportunidades"
    },
    {
      icon: Smartphone,
      title: "Multi-canal",
      description: "Integração com WhatsApp, site, redes sociais e mais"
    }
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-subtle">
      <div className="mx-auto max-w-4xl">
        <div className="text-center">{/* Changed to center and single column */}
          
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 badge-accessible mb-6">
              <Bot size={16} />
              Veja o Agente de SDR em ação
            </div>
            
            <h2 className="text-heading text-foreground mb-6">
              Resultado real, sem{" "}
              <span className="bg-gradient-hero bg-clip-text text-transparent">
                encenação
              </span>
            </h2>

            <p className="text-body-large text-muted-foreground mb-8 leading-relaxed max-w-3xl mx-auto">
              Veja um atendimento feito 100% pela nossa IA, da primeira mensagem até a qualificação do lead.
            </p>

            {/* Features */}
            <div className="grid md:grid-cols-3 gap-6 mb-8 max-w-4xl mx-auto">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="text-center">
                    <div className="flex items-center justify-center w-12 h-12 bg-accent/20 rounded-lg mx-auto mb-3">
                      <Icon size={24} className="text-secondary" />
                    </div>
                    <h3 className="font-semibold text-foreground mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-muted-foreground text-sm">
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="hero" size="lg" onClick={handleDemoClick}>
                Ver Demonstração Completa
              </Button>
              <Button variant="minimal" size="lg" onClick={handleChatClick}>
                Conversar com IA Agora
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Modal */}
      <ContactForm 
        isOpen={showContactForm} 
        onClose={handleFormClose}
      />
    </section>
  );
};

export default Solution;